export default {
  getWebsiteById: state => websiteId => {
    return state.websites.find(website => website.id === websiteId);
  },

  getLocationById: state => locationId => {
    return state.selectedWebsite.search_locations.find(
      location => location.id === locationId
    );
  }
};
